import React, { FC } from 'react';

/** What the in-take appointment is: a short card on mobile, a heading and paragraph on desktop. */
const BookingIntro: FC = () => (
  <div className="mb-4 md:mb-6">
    <div className="md:hidden p-3 rounded-xl border border-slate-200 flex gap-3 items-start mb-4">
      <span className="w-8 h-8 flex-shrink-0 rounded-md bg-brand bg-opacity-10 flex items-center justify-center text-base">🗓️</span>
      <span>
        <b className="block text-sm font-bold text-slate-800">Telehealth in-take · 40–45 min</b>
        <small className="block text-xs text-slate-500 leading-snug mt-0.5">
          A mental health clinician reviews your history and matches you with the right psychiatrist.
        </small>
      </span>
    </div>
    <div className="hidden md:block text-center mb-6">
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-2xl mb-3 bg-brand bg-opacity-10">
        <span className="text-2xl">📅</span>
      </div>
      <h2 className="text-xl font-bold mb-2 text-brand-dark">Book Your In-Take Appointment</h2>
      <p className="text-slate-500 text-sm leading-relaxed max-w-lg mx-auto">
        This is an initial
        {' '}
        <strong className="text-slate-700">telehealth in-take appointment (40–45 mins)</strong>
        {' '}
        with one of our experienced mental health clinicians. They will review your medical, family, and social history, answer any general questions, and match you with the most suitable psychiatrist for your assessment.
      </p>
    </div>
  </div>
);

export default BookingIntro;
